module.exports = __webpack_public_path__ + "fdcde8e96f1c12e24baca02324cc6ec5.svg";